<template>
    <div class="landing-page-container" :style="containerBgStyle">
        <button type="button" class="back-button" @click="jumpHome">
            <img class="back-arrow" src="@/assets/images/icon.png" alt="返回">
            <span>返回</span>
        </button>
        <div class="custom-module" v-for="(item, index) in visibleModules"
            :key="item.id || item.moduleType || index">
            <img v-if="item.imageUrl" :src="resolveImage(item.imageUrl)" class="module-image"
                :class="{ clickable: item.linkUrl }" :alt="item.title || '活动图片'"
                :loading="Number(item.moduleType) === 1 ? 'eager' : 'lazy'" @click="jumpUrl(item.linkUrl)">
            <div v-if="isProductModule(item) && !item.hide && item.items && item.items.length" class="product-info">
                <div class="product-content">
                    <div class="product-list" v-for="(product, productIndex) in productsForModule(item)"
                        :key="product.id || product.productId || productIndex"
                        @click="handleProductClick(product)">
                        <img :src="productImage(product)" :alt="product.productName || '活动商品'" loading="lazy">
                        <div class="product-desc">
                            <p :title="product.productName">{{ product.productName }}</p>
                            <div class="price">
                                <span class="rmb">¥</span>
                                <b class="amount">{{ productPrice(product) }}</b>
                                <span v-if="product.realDiscountStatus">到手价</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="not-data" v-if="loading && !error && modules.length === 0">
            <img src="@/assets/images/not-happy.png" alt="">
            <p>活动已失效 ~</p>
            <div class="button" @click="jumpHome">返回商城首页</div>
        </div>
        <div class="not-data" v-if="error">
            <img src="@/assets/images/not-happy.png" alt="">
            <p>活动加载失败，请稍后再试</p>
            <div class="button" @click="getCustomActivityRender">重新加载</div>
        </div>
    </div>
</template>

<script>
import { customActivityRender } from '@/services/http';

export default {
  name: 'LandingPage',
  data() {
    return {
      modules: [], // 活动图列表 模块类型 1头图 2活动信息 3活动信息1 4推荐商品 5自定义商品列表 6自定义商品列表1 7跳转按钮
      bgColorList: [],
      loading: false,
      error: false,
      requestPending: false
    };
  },
  created() {
    this.getCustomActivityRender();
  },
  computed: {
    visibleModules() {
      return this.modules.filter((item) => !(this.isProductModule(item) && !(item.items && item.items.length)));
    },
    containerBgStyle() {
      if (this.bgColorList.length === 0) {
        return {};
      }
      if (this.bgColorList.length === 1) {
        return {
          background: this.bgColorList[0]
        };
      }
      return {
        background: `linear-gradient(to bottom, ${this.bgColorList.join(', ')})`
      };
    }
  },
  methods: {
    async getCustomActivityRender() {
      if (this.requestPending) return;
      this.loading = false;
      this.error = false;
      this.bgColorList = [];
      this.requestPending = true;
      try {
        const res = await customActivityRender({
          companyId: 1,
          activityId: this.$route.query.activityId,
          // PC 端活动数据。
          platform: 3
        });
        const payload = res && res.data && res.data.data;
        this.modules = payload && Array.isArray(payload.modules) ? payload.modules : [];
        this.bgColorList = payload && payload.page && Array.isArray(payload.page.bgColorList)
          ? payload.page.bgColorList : [];
      } catch (e) {
        this.error = true;
        this.modules = [];
      } finally {
        this.loading = true;
        this.requestPending = false;
      }
    },
    isProductModule(item) {
      return [4, 5, 6].indexOf(Number(item.moduleType)) !== -1;
    },
    productsForModule(item) {
      const items = item && Array.isArray(item.items) ? item.items : [];
      // 推荐商品最多展示 10 个；自定义商品列表按后台返回数量展示。
      return Number(item && item.moduleType) === 4 ? items.slice(0, 10) : items;
    },
    resolveImage(image) {
      if (typeof image === 'string') return image;
      return image && (image.cdnFilePathPc || image.cdnFilePath || image.cdnFilePathH5
                || image.cdnFilePathMobile || image.url || image.filePath) || '';
    },
    productImage(product) {
      return this.resolveImage(product.listImagePath || product.imagePath || product.imageUrl);
    },
    productPrice(product) {
      if (product.realDiscountStatus && product.realDiscountPrice != null) return product.realDiscountPrice;
      const lowest = product.lowestPrice == null ? '' : String(product.lowestPrice);
      return lowest.split(',')[0];
    },
    // 活动商品跳转
    handleProductClick(product) {
      this.$router.push(`/details?id=${product.id}`);
    },
    // 图片跳转
    jumpUrl(url) {
      if (!url) return;
      if (/^https?:\/\//i.test(url)) window.location.href = url;
      else this.$router.push(url);
    },
    jumpHome() {
      this.$router.push('/');
    }
  }
};
</script>

<style scoped lang="scss">
.landing-page-container {
    width: 100%;
    min-height: 100vh;
    padding-bottom: 56px;
    position: relative;
    overflow-x: hidden;

    .back-button {
        position: fixed;
        top: 32px;
        left: 32px;
        z-index: 100;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 16px;
        width: 144px;
        height: 64px;
        padding: 0;
        border: 0;
        border-radius: 50px;
        background: rgba(0, 0, 0, 0.6);
        color: #FFFFFF;
        font-size: 32px;
        line-height: 1;
        cursor: pointer;

        &:focus {
            outline: 2px solid rgba(255, 255, 255, 0.9);
            outline-offset: 2px;
        }
    }

    .back-arrow {
        width: 32px;
        height: 32px;
    }

    .custom-module {

        .module-image {
            display: block;
            width: 100%;
            cursor: pointer;

            &.active {
                padding-bottom: 16px;
            }
        }

        .product-info {
            margin-bottom: 20px;

            .product-content {
                width: 1200px;
                margin: 0 auto;
                display: flex;
                flex-wrap: wrap;

                .product-list {
                    width: 220px;
                    height: 342px;
                    margin: 0 20px 20px 0;
                    background: #FFFFFF;
                    border-radius: 4px;
                    cursor: pointer;

                    &:nth-child(5n) {
                        margin-right: 0;
                    }

                    img {
                        width: 220px;
                        height: 220px;
                        display: block;
                        border-top-left-radius: 4px;
                        border-top-right-radius: 4px;
                    }

                    p {
                        font-size: 15px;
                        line-height: 21px;
                        max-height: 42px;
                        width: 196px;
                        // 两行省略（不能与 white-space: nowrap 同时使用）
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        line-clamp: 2;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        word-break: break-word;
                        margin-bottom: 24px;
                    }

                    .price {
                        .rmb {
                            font-size: 18px;
                            color: #FF0000;
                            font-weight: bold;
                        }

                        .amount {
                            font-size: 18px;
                            color: #FF0000;
                            font-weight: bold;
                            margin-right: 5px;
                        }

                        span {
                            font-size: 14px;
                            color: #FF0000;
                        }
                    }
                }

                .product-desc {
                    padding: 12px;
                }
            }
        }
    }

    .not-data {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate3d(-50%, -50%, 0);
        -webkit-transform: translate3d(-50%, -50%, 0);
        text-align: center;

        img {
            display: block;
            width: 80px;
            height: 80px;
            margin: 0 auto 14px;
        }

        p {
            font-size: 20px;
            margin-bottom: 27px;
        }

        .button {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 140px;
            height: 32px;
            border-radius: 16px;
            border: 1px solid #999999;
            opacity: 0.8;
            text-align: center;
            line-height: 32px;
            font-size: 14px;
            cursor: pointer;
        }
    }

}
</style>
